import React from "react";
import { useSelector } from "react-redux";
import ProgressBar from "./ProgressBar.tsx";
import Loading from "./Loading1";
export default function LoadBar(props) {
  const { offers, view } = props;
  const loading = useSelector((state) => state.system.loading);
  const isloadertext = useSelector((state) => state.system.isloadertext);
  const hotelCount = useSelector((state) => state.filter.hotelCount);

  return (
    <>
      {loading > 0 && (
        <>
          <ProgressBar
            barContainerClassName="barcontainer"
            completedClassName="barcontainercomplete"
            completed={offers.length}
            maxCompleted={view === "offers" ? hotelCount : 500}
            customLabel="&nbsp;"
            animateOnRender={false}
          />
          {1==0&&<div
            style={{
              borderRadius: "5px",
              position: "fixed",
              top: "0",
              left: "0",
              height: "100%",
              width: "100%",
              zIndex: 100000,
              //opacity: 0.2,
              //"-webkit-filter": "blur(5px)" /* Safari 6.0 - 9.0 */,
              //filter: "blur(5px)",
              //backdropFilter: "blur(25px)",
              //backgroundColor: "rgba(0,0,0,0.1)",
              verticalAlign: "middle",
              textAlign: "center",
              fontSize: "15pt",
              backgroundColor: "rgba(255, 255, 255, 0.8",
            }}
          >
            <div
              style={{
                width: "350px",
                height: "100px",
                margin: "auto",
                marginTop: "10%",
              }}
            >
              <img
                src="https://images.fiboxx.de/loading.gif"
                style={{ height: "100px" }}
              ></img>
            </div>

            {isloadertext && (
              <>
                {props.text ? (
                  <span style={{ fontSize: "1em" }}>{props.text}</span>
                ) : undefined}
              </>
            )}
          </div>}
        </>
      )}
    </>
  );
}
